<template>
  <div>
    <h4>{{ headline }}</h4>
    <h5 v-show="stateFilterLength > 0">{{ choosenFilter }}</h5>
    <ul>
      <li v-for="(item, name) in stateFilter" :key="item.id" v-html="format(item, name)" />
    </ul>
    <ul>
      <li v-for="item in resultItems" :key="item.id">
        <a v-bind:href="'/downloads/' + item.pdf" target="_blank">{{ item.pdf }}</a>
      </li>
    </ul>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

import { getString, getSectionTitle, getSectionValueTitle } from '../../language'

export default {
  name: 'StoCscContactSummary',
  data: function () {
    return {
      headline: getString('contact.summary.headline'),
      choosenFilter: getString('contact.summary.choosenFilter')
    }
  },
  computed: {
    ...mapGetters({
      stateFilter: 'filter/stateFilter',
      resultItems: 'results/items',
      formData: 'contact/formData'
    }),
    stateFilterLength: function () {
      return Object.keys(this.stateFilter).length
    }
  },
  methods: {
    format (item, name) {
      return getSectionTitle(name) + ': ' + getSectionValueTitle(name, item.values[0])
    }
  }
}
</script>
